import { Button, Flex } from '../../components';
import Container from './Container';
import PageHeading from './PageHeading';
import AppIconAnimation from './AppIconAnimation';
import FeatureBlocks, { FeatureDescription } from '../FeatureBlocks';
import { howItWorksQuery } from '../../core-types';
import { useAppLinkProps } from '../../components/AppLink';
import { BlockContent } from '../../components/BlockContent';
import { FormattedMessage } from 'react-intl';
import { NavLink } from '../Article/NavLink';

type Props = {
  data: howItWorksQuery;
  appContent: boolean;
};

const HowItWorks = ({ data, appContent }: Props) => {
  const { system, howItWorksPage } = data;

  const appLinkProps = useAppLinkProps();

  if (!system || !howItWorksPage) {
    return null;
  }

  const isFileObjectEmpty =
    data?.howItWorksPage?.file &&
    Object.keys(data?.howItWorksPage?.file).length === 0;

  return (
    <>
      {!appContent && (
        <Container textAlign="center" mb="lg">
          <PageHeading data-testid="HowItWorks__Heading" mb="lg">
            {howItWorksPage.heading || howItWorksPage.title}
          </PageHeading>
          <AppIconAnimation />
          <FeatureDescription>
            <BlockContent blocks={howItWorksPage.description} />
          </FeatureDescription>
          <Flex justifyContent="center">
            <Button
              as="a"
              variant="primary"
              shape="cool"
              data-testid="HowItWorks__AppLink"
              {...appLinkProps}
            />
          </Flex>
          {!isFileObjectEmpty && (
            <Flex justifyContent="center" mt={5}>
              <NavLink
                textDecoration="underline"
                href={`${data?.howItWorksPage?.file.file}?dl=`}
              >
                <FormattedMessage
                  id="modules.FeatureBlocks.HowItWorks.downloadUserGuide"
                  defaultMessage="Download user guide"
                />
              </NavLink>
            </Flex>
          )}
        </Container>
      )}
      <FeatureBlocks
        featureBlocks={howItWorksPage.featureBlocks}
        appContent={appContent}
      />
    </>
  );
};

export default HowItWorks;
